export default {
  editShopHomepagePage: 'Edit Shop Homepage Page',
  save: 'Save',
  componentLibrary: 'Component Library',
  dragAndDropToUse: 'Drag and Drop to Use',
  dropHere: 'Drop Here',
  layer: 'Layer',
  send: 'Send',
  copy: 'Copy',
  delete: 'Delete',
  componentSettings: 'Component Settings',
  componentRemarks: 'Component Remarks',
  editCoordinates: 'Edit Coordinates',
  coordinateSelection: 'Coordinate Selection',
  pleaseSelectALocation: 'Please Select a Location',
  pleaseSelectProduct: 'Please Select a Product',
  atLeast2ComponentsRequiredForThematicPage: 'At least 2 components required for thematic page',
  previous: 'Previous',
  cancel: 'Cancel',
  confirm: 'Confirm',
  pleaseCheckIfTheThematicPageIDIsCorrect: 'Please check if the thematic page ID is correct',
  thisActionWillPermanentlyRemoveTheComponent: 'This action will permanently remove the component, continue?',
  tip: 'Tip',
  successfullyDeleted: 'Successfully Deleted',
  deletionCanceled: 'Deletion Canceled',
  onlyOneInstanceOfThisComponentCanBeAdded: 'Only one instance of this component can be added',
  over30ComponentsCauseLag: 'The current page has over 30 components, which may cause lag. It is recommended to simplify the components.',
  areYouSureYouWantToCopy: 'Are you sure you want to copy?',
  copiedComponentPlacedAtEndByDefault: 'The copied component will be placed at the end by default',
  pleaseSelectCoordinates: 'Please select coordinates',
  commandExecutionSuccessful: 'Command execution successful',
  savedSuccessfullyCheckViaApp: 'Saved successfully, check the latest effect on the store homepage via the mobile app',
  carouselAd: 'Carousel Ad',
  hotSpotImage: 'Hot Spot Image',
  title: 'Title',
  productComponent: 'Product Component',
  subtitle: 'Subtitle',
  pleaseSelect: 'Please Select',
  actionTypesAfterClick: 'There are 4 types of actions after clicking',
  carouselInterval: 'Carousel Interval',
  recommendedSize: 'Recommended Size',
  adLink: 'Ad Link',
  addImage: 'Add Image',
  dragUpAndDownToSort: 'Drag Up and Down to Sort',
  submit: 'Submit',
  loginSessionExpired: 'Login session has expired, please log in again to continue',
  imageUpload: 'Image Upload',
  hotspotManagement: 'Hotspot Management',
  hotspotItem: 'Hotspot Item',
  hotspotAdjustPositionSize: 'After adding a hotspot, click and drag the shape on the left to adjust its position and size',
  actionType: 'Action Type',
  addRectangle: 'Add Rectangle',
  addCircle: 'Add Circle',
  backgroundColor: 'Background Color',
  fontColor: 'Font Color',
  moreFontColor: 'More Font Color',
  redirectAddress: 'Redirect Address',
  position: 'Position',
  alignLeft: 'Align Left',
  center: 'Center',
  productType: 'Product Type',
  onePerRow: 'One per row',
  twoPerRow: 'Two per row',
  threePerRow: 'Three per row',
  multiplePerRow: 'Multiple per row',
  componentColor: 'Component Color',
  selectProduct: 'Select Product',
  pinToTop: 'Pin to Top',
  outOfStock: 'Out of Stock',
  search: 'Search',
  upTo200ProductsCanBeAdded: 'Up to 200 products can be added',
  bulkAdd: 'Bulk Add',
  selectedProducts: 'Selected Products',
  youHaveSelectedXProducts: 'You have selected x products',
  adjustOrderOfProducts: 'You can adjust the order of the products',
  productInformation: 'Product Information',
  price: 'Price',
  sort: 'Sort',
  operate: 'Operate',
  option1: 'Option 1',
  option2: 'Option 2',
  pleaseEnterQuantityForBulkAdding: 'Please enter the quantity for bulk adding',
  cannotExceed200AtMaximum: 'Cannot exceed 200 at maximum',
  failedToRetrieveDataRetry: 'Failed to retrieve data, please retry',
  saveError: 'Save Failed',
  homePageDesign: 'Home Page Design',
  storeKeywords: 'Store Keywords',
  enterKeywordsToSearchForProductsInStore: 'Enter keywords to search for products in the store.',
  urlLink: 'URL Link',
  enterCompleteURLToBeRedirected: 'Enter the complete URL to be redirected to the specified link.',
  enterProductListingIDToViewDetails: 'Enter the product Listing ID to view product details page.',
  storeCategoryID: 'Store Category ID',
  pleaseInputStoreCategoryID: 'Please input the store category ID to explore products within a specific category.'
}
